export enum PriceRangeStyleTypeEnum {
  PRICE_PLP_SEARCH_CARD = 'PRICE_PLP_SEARCH_CARD',
  PRICE_PDP = 'PRICE_PDP',
  PRODUCT_MERCHANDISE = 'PRODUCT_MERCHANDISE',
  PRICEABOCHECKBOXCARD = 'PRICEABOCHECKBOXCARD',
  PRICESEARCHRESULTCARD = 'PRICESEARCHRESULTCARD',
  PRICE_RANGE = 'PRICE_RANGE',
}
